import { makeStyles } from '@material-ui/core/styles';
import { Theme, SurfaceColors, TextColors, SecondaryColors } from '@/utils/constants';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      [muiTheme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    headerMobile: {
      zIndex: 1,
    },
    detailContent: {
      ...muiTheme.typography.body1,
    },
    sidebar: {
      [muiTheme.breakpoints.down('sm')]: {
        display: 'none',
      },
      [muiTheme.breakpoints.up('md')]: {
        width: 'calc(25% + 40px)',
        paddingRight: muiTheme.spacing(5),
      },
    },
    content: {
      [muiTheme.breakpoints.up('md')]: {
        width: 'calc(75% - 40px)',
      },
      [muiTheme.breakpoints.down('sm')]: {
        marginLeft: muiTheme.spacing(-4),
        marginRight: muiTheme.spacing(-4),
        width: `calc(100% + ${muiTheme.spacing(8)}px)`,
      },
    },
    headerDesktop: {
      display: 'none',

      [muiTheme.breakpoints.up('md')]: {
        display: 'block',
      },
    },
    partnerMessage: {
      backgroundColor: SurfaceColors.light,
      color: TextColors.dark,
      padding: muiTheme.spacing(2, 4),
      borderRadius: '4px',
    },
    block: {
      animation: 'enter 250ms ease-out',
      marginBottom: muiTheme.spacing(3.5),

      '&.header': {
        paddingTop: muiTheme.spacing(2.5),
      },

      '& article em': {
        'font-style': 'normal',
        'font-weight': 'bold',
      },
    },
    tags: {
      marginTop: muiTheme.spacing(3),
      marginBottom: muiTheme.spacing(3),
      padding: muiTheme.spacing(0, 4),

      [muiTheme.breakpoints.up('md')]: {
        marginBottom: muiTheme.spacing(0),
        padding: 0,
      },

      '& > *': {
        animation: 'enter 250ms ease-out',
      },
    },
    chip: {},
    pagination: {
      '& .MuiPagination-ul': {
        justifyContent: 'center',

        [muiTheme.breakpoints.up('md')]: {
          justifyContent: 'flex-end',
          marginRight: -14,
        },
      },

      '& .MuiPaginationItem-root': {
        ...muiTheme.typography.body1,
        color: TextColors.dark,
      },

      '& .Mui-selected': {
        background: 'transparent',
        color: SecondaryColors.dark,
      },
    },
  }),
  { name: 'GenSearchResults' },
);

export default useStyles;
